import { Box } from '@chakra-ui/react';

export const PencilSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <Box>
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" {...props}>
        <g clipPath="url(#clip0_2142_31607)">
          <path
            d="M7.79102 1.375C7.91139 1.25462 8.0543 1.15913 8.21159 1.09398C8.36887 1.02883 8.53744 0.9953 8.70768 0.9953C8.87792 0.9953 9.0465 1.02883 9.20378 1.09398C9.36106 1.15913 9.50397 1.25462 9.62435 1.375C9.74473 1.49537 9.84022 1.63828 9.90537 1.79557C9.97051 1.95285 10.004 2.12142 10.004 2.29166C10.004 2.4619 9.97051 2.63048 9.90537 2.78776C9.84022 2.94504 9.74473 3.08795 9.62435 3.20833L3.43685 9.39583L0.916016 10.0833L1.60352 7.5625L7.79102 1.375Z"
            stroke="#BCC7D7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2142_31607">
            <rect width="11" height="11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
};

export default PencilSVG;
